<div class="research-study-detail">
  <div class="container-custom">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
      <span class="fa fa-times close-icon" role="button" (click)="closeModal()"></span>
    </div>

    <div class="study-title mb-3">
      {{ researchStudyData?.study_name || 'Research Study Detail' }}
    </div>

    <div class="detail-card mb-3">
      <h6 class="section-title">Basic Information</h6>
      <div class="row g-3 mt-1">
        <div class="col-md-6">
          <div class="label">By Whom</div>
          <div class="value">{{ researchStudyData?.by_whom || '-' }}</div>
        </div>
        <div class="col-md-6">
          <div class="label">Registry Title</div>
          <div class="value">{{ researchStudyData?.registry_title || '-' }}</div>
        </div>
        <!-- <div class="col-md-4">
          <div class="label">Status</div>
          <div class="value">
            {{ researchStudyData?.deleted ? 'Inactive' : 'Active' }}
          </div>
        </div> -->
        <div class="col-md-6">
          <div class="label">Global Tag</div>
          <div class="value">
            <span class="global-tag-chip">
              {{ researchStudyData?.global_tag_name || researchStudyData?.global_tag_id || '-' }}
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="label">Duration</div>
          <div class="value">{{ researchStudyData?.duration_of_study || '-' }}</div>
        </div>
      </div>
    </div>

    <div class="detail-card mb-3">
      <h6 class="section-title">Who Can Join</h6>
      <ul class="detail-list" *ngIf="whoCanJoinItems.length; else emptyWhoCanJoin">
        <li *ngFor="let item of whoCanJoinItems">{{ item }}</li>
      </ul>
      <ng-template #emptyWhoCanJoin>
        <div class="value">-</div>
      </ng-template>
    </div>

    <div class="detail-card" *ngIf="completionDocumentNames.length">
      <h6 class="section-title">Documents</h6>
      <ul class="detail-list">
        <li *ngFor="let docName of completionDocumentNames">{{ docName }}</li>
      </ul>
    </div>
  </div>
</div>
